import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const AREA_LIBRARY = API_URL + "/library/";

const CATEGORY_BASEURL = AREA_LIBRARY + "category/";
const CLASSIFICATION_BASEURL = API_URL + "/LibraryClassification/";
// const POST_BASEURL = AREA_LIBRARY + "post/";
const POST_BASEURL = API_URL + "/LibraryPost/";
const TAG_BASEURL = AREA_LIBRARY + "tag/";
const POSTACCESSHISTORY_BASEURL = API_URL + "/LibraryPostAccessHistory/";

export const LibraryAdminApi = {
  getCategoryList,
  updatCategoryOrder,
  getCategory,
  saveCategory,
  deleteCategory,
  getPost,
  savePost,
  deletePost,
  updatePostOrder,
  validateLibraryPostFile,
  getClassificationList,
  getTagList,
  saveTag,
  deleteTag,
  searchPostAccessHistory,
  exportPostAccessHistory,
  getOrganizationNames,
};

function getCategoryList() {
  return axios.get(CATEGORY_BASEURL + "getall");
}

function updatCategoryOrder(data) {
  return axios.post(CATEGORY_BASEURL + "updateorder", data);
}

function getCategory(id) {
  return axios.get(CATEGORY_BASEURL + "get/" + id);
}

function saveCategory(data) {
  return axios.post(CATEGORY_BASEURL + "save", data);
}

function deleteCategory(id) {
  return axios.get(CATEGORY_BASEURL + "delete/" + id);
}

function getPost(id) {
  return axios.get(POST_BASEURL + "Get/" + id);
}

function savePost(data) {
  return axios.post(POST_BASEURL + "Save", data);
}

function deletePost(id) {
  return axios.post(POST_BASEURL + "Delete/" + id);
}

function validateLibraryPostFile(data) {
  return axios.post(POST_BASEURL + "ValidateFile", data);
}

function updatePostOrder(data) {
  return axios.post(POST_BASEURL + "UpdateList", data);
}

function getClassificationList() {
  return axios.get(CLASSIFICATION_BASEURL + "GetAll");
}

function getTagList(skipCount, sorting, dsc) {
  return axios.get(TAG_BASEURL + "getList");
}

function saveTag(data) {
  return axios.post(TAG_BASEURL + "save", data);
}

function deleteTag(id) {
  return axios.get(TAG_BASEURL + "delete/" + id);
}

function searchPostAccessHistory(skipCount, sorting, dsc, filter) {
  let data = prepareFilterParams(skipCount, sorting, dsc, filter);
  return axios.post(POSTACCESSHISTORY_BASEURL + "GetListByFilters", data);
}

function exportPostAccessHistory(skipCount, sorting, dsc, filter) {
  let data = prepareFilterParams(skipCount, sorting, dsc, filter);
  return axios.post(POSTACCESSHISTORY_BASEURL + "ExportListByFilters", data, {
    responseType: "blob",
  });
}

function prepareFilterParams(
  skipCount = 0,
  sorting = null,
  dsc = false,
  filter = null
) {
  if (dsc) {
    sorting += " desc";
  }

  let data = {
    skipCount: skipCount,
    sorting: sorting,
  };
  if (filter != null) {
    data.userId = filter.userId;
    data.organizationId = filter.organizationId;
    data.libraryPostTitle = filter.libraryPostTitle;
    data.libraryCategoryName = filter.libraryCategoryName;
    data.dateTo = filter.dateTo;
    data.dateFrom = filter.dateFrom;
  }

  return data;
}

function getOrganizationNames() {
  return axios.get(POSTACCESSHISTORY_BASEURL + "GetOrganizationNames");
}
